import firebase from "firebase/app";
import "firebase/auth";

export const SET_AUTHENTICATED = (state, authenticated) => {
  state.authenticated = authenticated;
};

export const LOGOUT = state => {
  firebase.auth().signOut();
  state.authenticated = false;
};

export const SET_LOCALE = (state, data) => {
  state.locale = data;
};

export const SET_PORTAL_SETTINGS = (state, data) => {
  state.portal_settings = data;
};
